import { OrganizationManagerUser } from 'model/organizationManager';
import { OrganizationManagerDto, SaveOrganizationManagerUserDto } from './OrganizationManagerDtos';

/**
 * Convert OrganizationManager DTO to OrganizationManagerUser Model
 * Converts from snake_case (API format) to camelCase (domain model)
 *
 * The response is user-centric: account fields sit at the root and the
 * membership id arrives as `organization_manager_id`. Keep the two ids
 * distinct - `id` is the person, `organizationManagerId` is their membership.
 */
export const convertToOrganizationManagerUser = (dto: OrganizationManagerDto): OrganizationManagerUser => {
    return {
        id: dto.id,
        organizationManagerId: dto.organization_manager_id,
        organizationId: dto.organization_id,
        accessLevelId: dto.access_level_id,
        owner: dto.owner,
        firstName: dto.first_name,
        lastName: dto.last_name,
        email: dto.email,
        passwordDigest: dto.password_digest,
        phone: dto.phone,
        token: dto.token,
        tokenTemporal: dto.token_temporal,
        emailOptout: dto.email_optout,
        admin: dto.admin,
        active: dto.active,
        createdAt: dto.created_at,
        updatedAt: dto.updated_at,
        notificationsOptout: dto.notifications_optout,
        orgAccessLevelId: dto.org_access_level_id,
        name: dto.name,
        image: dto.image,
        marketplaceId: dto.marketplace_id,
        profileComplete: dto.profile_complete,
        staffId: dto.staff_id
    };
};

/**
 * Convert OrganizationManagerUser Model to SaveOrganizationManagerUserDto
 * Converts from camelCase (domain model) to snake_case (API format)
 */
export const convertToSaveOrganizationManagerUserDto = (
    organizationManagerUser: Partial<OrganizationManagerUser>
): SaveOrganizationManagerUserDto => {
    return {
        first_name: organizationManagerUser.firstName,
        last_name: organizationManagerUser.lastName,
        email: organizationManagerUser.email,
        phone: organizationManagerUser.phone,
        email_optout: organizationManagerUser.emailOptout,
        admin: organizationManagerUser.admin,
        active: organizationManagerUser.active,
        notifications_optout: organizationManagerUser.notificationsOptout,
        org_access_level_id: organizationManagerUser.orgAccessLevelId,
        image: organizationManagerUser.image,
        marketplace_id: organizationManagerUser.marketplaceId,
        profile_complete: organizationManagerUser.profileComplete,
        staff_id: organizationManagerUser.staffId
    };
};
